import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import { authMapGetters, authGetters } from '@common/store/modules';
import {
  mapActions as shopMapActions,
  mapState as shopMapState,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as mapEstimateActions,
  mapGetters as mapEstimateGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';
import {
  mapActions as userMapActions,
  mapState as userMapState,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import EstimationListModal from './modal/EstimationListModal';
import StoreProfileModal from './modal/StoreProfile';
import EstimationDetailModal from '@/front/customer/views/mypage/modal/EstimationDetailModal';
import { sleep, isApp } from '@common/lib/common/utils';
import BaseRoom from './BaseRoom';

export default {
  components: {
    ...BaseRoom.components,
  },
  name: 'SystemRoom',
  data() {
    return {
      ...BaseRoom.data,
      chatRoomType: 'SYSTEM',
    };
  },
  computed: {
    ...BaseRoom.computed,
  },
  async beforeRouteEnter(to, from, next) {
    return BaseRoom.beforeRouteEnter(to, from, next);
  },
  beforeDestroy() {
    BaseRoom.beforeDestroy(this);
  },
  methods: {
    ...BaseRoom.methods,
    ...chatMapActions([chatActions.SET_CHATROOM]),
    //채팅룸 정보
    async initFetch() {
      this.isSocketStatusToast = false;
      //채팅방 정보 가져오기.
      await this.getChatRoom();
      await this.setChatRoom();
    },
    //채팅방 정보 가져오기.
    async getChatRoom() {
      await this[chatActions.FETCH_CHATROOMS]({
        chatRoomType: this.chatRoomType,
      });
      //console.log(this.isCreateMode, this.chatrooms_with, this.chatrooms);
      if (this.chatrooms.content.length === 0) {
        this.isCreateMode = true;
      } else {
        //console.log(this.chatrooms);
        this[chatActions.SET_CHATROOM](this.chatrooms.content[0]);
        this.uuid = this.chatroom.uuid;
        /*await this[chatActions.FETCH_CHATROOM]({
          uuid: this.uuid,
        });*/
      }
    },
    async setChatRoom(isFromCreate) {
      if (this.isCreateMode) {
        if (this.chatrooms.content.length === 0) {
          this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
            messages: [
              {
                type: 'SYSTEM',
                message: JSON.stringify({
                  text:
                    '퍼스을 이용하시면서 궁금한점, 불편한점 및 건의할 점이 있으면 문의를 작성 해주세요.\n문의하신 내용에 따라 답변이 늦어질 수 있습니다.',
                }),
                messageIdx: 0.1,
                createdAt: new Date().toISOString(),
              },
            ],
            append: true,
          });
          this.messages = this.chatmessages;
        } else {
          /*this.$router.replace({
            name: 'chat.room',
            params: {
              uuid: this.chatrooms_with.content[0].uuid,
            },
          });*/
        }
      } else {
        this.messageIdx = this.chatroom.messageIdx;
        await this.syncChatRoom();
        if (!isFromCreate) this.infiniteId += 1; //리스트 가져오기.
      }
    },

    //채팅방 생성
    async createChatRoom() {
      await this[chatActions.CREATE_CHATROOM]({
        chatRoomType: this.chatRoomType,
        memberId: 1, //admin(server에서 재조회함.)
      });
      this.isCreateMode = false;
      this.uuid = this.chatroom.uuid;
      //채팅룸 생성 완료
      const dt = new Date().toISOString();
      /*await this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
        messages: [
          {
            type: 'DATE',
            message: JSON.stringify({
              date: format(parseISO(dt), 'yyyy-MM-dd'),
            }),
            messageIdx: 0.2,
            createdAt: dt,
          },
        ],
        append: true,
      });*/

      /*await this[chatActions.RECEIVE_CHATMESSAGE]({
        uuid: this.chatroom.uuid,
        messageIdx: 0.1,
        messages: this.chatmessages.flatMap(m => {
          m.message = JSON.stringify(m.message);
          return m;
        }),
        append: true,
        skipStore: true,
      });*/

      await this.setChatRoom(true);

      this.initNetworkEvents();
      const result = await this.connectToWebsocket();
      this[chatActions.CHATMESSAGES_RESET_STATE]();
      //console.log('result', result);
      if (result) {
        await sleep(500);
        this.sendMessage('TEXT');
      }
      this.handleForeground();
    },
    // 채팅 입력창 줄바꿈 처리
    textareaMessage(e) {
      if (isApp()) {
        this.$refs.textbox.style.height = '4rem';
        this.$refs.textbox.style.height =
          this.$refs.textbox.scrollHeight + 'px';
      } else {
        e.preventDefault();
        if (e.keyCode === 13) {
          if (!e.shiftKey) {
            this.message = this.message.trim();
            if (this.message != '') {
              this.sendMessage('TEXT');
              this.$nextTick(() => {
                this.$refs.textbox.style.height = '4rem';
                this.$refs.textbox.value = '';
                this.message = '';
              });
            }
          } else {
            this.$refs.textbox.style.height = '4rem';
            this.$refs.textbox.style.height =
              this.$refs.textbox.scrollHeight + 'px';
          }
        }
      }

      const textbox_val = this.$refs.textbox.value.trim();
      // 채팅메시지 임시 저장
      localStorage.setItem(`chatroom-input-${this.uuid}`, textbox_val);
    },
  },
};
